import { Link } from "wouter";
import { ArrowLeft, Megaphone } from "lucide-react";

import { Button } from "@/components/ui/button";
import { FeedbackForm } from "@/components/FeedbackForm";

export default function FeedbackPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100">
      <div className="mx-auto flex w-full max-w-5xl flex-col gap-8 px-6 py-12 sm:px-8">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <Link href="/dashboard">
            <Button variant="ghost" size="sm" className="w-fit">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to dashboard
            </Button>
          </Link>
          <div className="inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/5 px-4 py-2 text-sm text-primary">
            <Megaphone className="h-4 w-4" />
            Share your feedback to help us level up every release.
          </div>
        </div>

        <div className="mx-auto w-full max-w-3xl">
          <FeedbackForm />
        </div>
      </div>
    </div>
  );
}
